/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
angular.module('comcast.common.communication').factory('AuthenticationResourceFactory', ['$resource', 'EndPointService', 'NotificationInterceptor', function ($resource, ResourceEndPointService, NotificationInterceptor) {
  'use strict';

  return $resource(ResourceEndPointService.passwordResetEndPoint, {
    email: '@email'
  }, {
    // Reset a password
    resetPassword: {
      method: 'POST',
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('password').setAction('Resetting')
    },
    // Resource handler to change a user's password
    changePassword: {
      method: 'POST',
      url: ResourceEndPointService.passwordChangeEndPoint,
      params: {
        oldPass: '@oldPass',
        newPass: '@newPass'
      },
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('password').setAction('Changing')
    },
    login: {
      method: 'POST',
      url: ResourceEndPointService.loginEndpoint,
      params: {
        auth_user: '@user',
        auth_password: '@pass'
      },
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('password').setAction('Changing')
    },
    // No parameters are passed for acceptEula because passport.js on Node has access to the user session
    acceptEula: {
      method: 'GET',
      url: ResourceEndPointService.acceptEulaEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('EULA').setAction('Accepting')
    },
    viewEula: {
      method: 'GET',
      url: ResourceEndPointService.viewEulaEndPoint,
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('EULA').setAction('Retrieving')
    },
    switchAccount: {
      method: 'POST',
      url: ResourceEndPointService.switchAccountEndPoint,
      params: {
        new_account: '@account'
      },
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('Accounts').setAction('Switching')
    },
    getSessionKey: {
      method: 'GET',
      url: ResourceEndPointService.sessionKeyEndPoint,
      params: {},
      // No Params needed, because all our info is in the JWT
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('session key').setAction('Retrieving')
    }
  });
}]); //passwordResourceFactory.$changePassword({oldPass: $scope.oldPassword, newPass: $scope.newPassword}, function(success) {
//	$modalInstance.close(true);
//}, function(error) {
//	$scope.incorrectOldPassword = error.data === "Invalid password entered";
//});